<div class="row">
  <div class="col-4">
    <h6>LEGACY REFERRAL DETAILS</h6>
    <form>
      <div>Of the following, what data matches between 1) referral order and 2) prescriber details?</div>
      <div class="mb-3 mt-2">
        @for (matchOption of matchOptions; track matchOption) {
          <div class="form-check">
            <input
              [id]="matchOption.key"
              [name]="matchOption.key"
              class="form-check-input"
              type="checkbox"
              [disabled]="true"
              [(ngModel)]="legacyReferralMatchVerification[matchOption.key]"
              />
            <label class="form-check-label" [for]="matchOption.key"> {{ matchOption.display }} </label>
          </div>
        }
      </div>
    </form>
    <form class="form">
      <div class="mb-3 mt-2">
        <label for="notes">ADDITIONAL DETAIL</label>
        @if (!showAdditionalDetails) {
          <fa-icon
            [icon]="['fas', 'plus-square']"
            size="sm"
            (click)="onPlusClick()"
            />
        }
        @if (showAdditionalDetails) {
          <fa-icon
            [icon]="['fas', 'minus-square']"
            size="sm"
            (click)="onMinusClick()"
            />
        }
        @if (showAdditionalDetails) {
          <textarea
            id="notes"
            name="notes"
            class="form-control"
            [disabled]="true"
            [(ngModel)]="legacyReferralMatchVerification.notes"
            rows="5"
            >
          </textarea>
        }
      </div>
    </form>
  </div>
</div>
